import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { specraFocusRing } from './focus-ring';
/**
 * An inline, clickable term inside running text (a glossary acronym in a
 * title). It reads as the text it sits in, marked by a dotted underline, and
 * changes no metrics: no padding, inherited font and line height, so marking
 * a term never moves the line it is on. Cheap by design (no hooks, no
 * portal): a page may render hundreds; one shared SpecraPopover opens on
 * click.
 */ export const SpecraTerm = /*#__PURE__*/ React.forwardRef(({ className, type = 'button', ...props }, ref)=>/*#__PURE__*/ _jsx("button", {
        ref: ref,
        type: type,
        "aria-haspopup": "dialog",
        className: cn('m-0 inline cursor-help appearance-none rounded-sm border-0 bg-transparent p-0 align-baseline font-[inherit] text-inherit [line-height:inherit]', 'underline decoration-muted-foreground decoration-dotted underline-offset-2 hover:decoration-foreground', specraFocusRing, className),
        ...props
    }));
SpecraTerm.displayName = 'SpecraTerm';
